import React, { Component } from 'react';
import { message, Table , Spin, Button } from 'antd'
import axios from 'axios'

class ListAlerts extends Component {

    state ={
        loading :false
    }

    sendAlertRequest = (url) => {
        this.setState({
            loading:true
        },
        () => {
            axios.post(url)
            .then(response => {
                message.success("Alerts Sent")
                this.setState({loading:false})
            })
            .catch(err =>{
                console.error(err);
                message.error("Something wrong with sending alerts! Please try again later.")
                this.setState({loading:false})
                }       
            )
        } 
        )
       
    }

    data = [
        {
            alertTitle : "Overdue Alert",
            alertDescription : "Sends SMS alerts to all the customers who has the overdue amount by the current date. Standard SMS charges will apply",
            url : "/api/alert/sms/send_bulk/"

        }
    ]

    columns = [
        {   
            key : 0,
            title : "Alert Title",
            dataIndex : "alertTitle"
        }
        ,
        {   
            key : 1,
            title : "Alert Description",
            dataIndex : "alertDescription"
        }
        ,
        {   
            key : 2,
            title : "",
            dataIndex : "url",
            render : url => <Button onClick={() => this.sendAlertRequest(url)} > Send Alert</Button>


        }
    ]
   
    render() { 
        return ( 
            <Spin  tip="Please be patient, SMS alerts are being sent." spinning={this.state.loading}>
            <Table
                columns={this.columns}
                dataSource = {this.data}
             />
             </Spin>
         );
    }
}
 
export default ListAlerts;